<template>
<div>
    <organisations :organisations="organisations" :key="key" :organisationtypes="organisationTypes" @organisationChange="getOrganisations()"></organisations>
</div>
  
</template>

<script>
import Api from "@/services/Api";
import Organisation from '@/components/Organisation.vue';

export default {
    
  components: {
    organisations: Organisation
  },
  data(){
      return{
          key:0,
          organisations: [],
          organisationTypes: []
      }
  },
  async created(){
        this.initialize();
  },
  methods: {
      initialize(){
          this.getOrganisations();
          this.getOrganisationTypes();
      },
      getOrganisations(){
          Api()
          .get('/customer/organisation')
          .then(response=>{
              this.organisations=response.data
              this.key++
          })
      },
      getOrganisationTypes(){
          Api()
          .get('/organisationType')
          .then(response=>{
              this.organisationTypes=response.data
          })
      }
  }
}
</script>

<style>

</style>